import script from "./SelectionDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectionDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SelectionDetail.vue?vue&type=style&index=0&id=0a7c60fc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7c60fc"]])

export default __exports__